import React, { forwardRef } from "react";
import { useFormContext } from "react-hook-form";
import { Button } from "@components/buttons";
import { ButtonProps } from "./types";

export default forwardRef<
	HTMLButtonElement,
	ButtonProps & { additionalProps?: boolean }
>(function MyLimitsFormButton(props, ref) {
	const {
		formState: { dirtyFields, isSubmitting, errors, isValid },
	} = useFormContext();

	const isButtonDisabled =
		Object.keys(dirtyFields).length == 0 ||
		Object.keys(errors).length != 0 ||
		isSubmitting ||
		!isValid ||
		(props.additionalProps !== undefined && !props.additionalProps);

	return (
		<Button
			{...props}
			ref={ref}
			disabled={isButtonDisabled || props.disabled}
		/>
	);
});
